import { observer } from 'mobx-react';
import { ExperienceViewLogo } from '../../../../../../CurrentCollectionStep/BuilderV2/ProgramExperienceVideo';
import { ExperienceResource } from '../../../../../../CurrentCollectionStep/BuilderV2/Types';

export interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceSchoolThumbnail({ experienceResource }: Props) {
  return (
    <ExperienceViewLogo
      className="flex h-[11.125rem] w-full sm:h-35 sm:w-[15.5rem] rounded-t"
      height={38}
      name={experienceResource.payload.school_partner_name}
      links={experienceResource.links}
    />
  );
}

export default observer(ExperienceSchoolThumbnail);
